// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","footerContent":"Footer_footerContent__E5RXg","copyright":"Footer_copyright__QJwUC","footerLinks":"Footer_footerLinks__Mudwb"};